import Loadable from '../../components/loadable';

const EzidebitRefundModal = Loadable({
  loader: () => import('../../pages/invoices/ezidebit_refund_modal'),
  type: 'modal',
});

angular.module('gym').value('EzidebitRefundModal', EzidebitRefundModal);
